import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AddonsInvoiceStoreEffects } from './effects';
import { featureReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('addonsInvoice', featureReducer),
    EffectsModule.forFeature([AddonsInvoiceStoreEffects]),
  ],
})
export class AddonsInvoiceStoreModule {}
